module.exports = __webpack_public_path__ + "media/images/like_on-4f7846db1a87da08910ad7484ab95b36.svg";